import { Message } from '@messageformat/react';
import XRegExp from 'xregexp';

export const ValidateSelector = (
  value,
  id,
  newErrors,
  validateAll,
  questionID,
  errorLabel
) => {
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  }

  let invalid = false;

  if (value !== undefined) {
    invalid = value === 'choose' || value === '' || invalid;
  } else {
    invalid = validateAll || invalid;
  }

  if (invalid) {
    newErrors.add = [
      ...newErrors.add,
      { id, message: errorLabel || <Message id="errorText.invalidInput" /> },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

export const ValidatePropertyCode = (
  value,
  id,
  newErrors,
  validateAll,
  length,
  questionID,
  regExp,
  errorLabel
) => {
  const DELIMITER_HYPHEN = '-';
  if (value.indexOf(DELIMITER_HYPHEN) > -1) {
    let hasError = false;
    // Zero left pad values, if those are missing
    const parts = value.split(DELIMITER_HYPHEN);
    let result = '';
    (parts || []).forEach((record, index) => {
      if (index <= 1) {
        record = String(record).padStart(3, '0');
      } else if (index <= 3) {
        record = String(record).padStart(4, '0');
      } else if (index === 4) {
        //Should start with M & m..Like M0601
        if (!record.startsWith('M') && !record.startsWith('m')) {
          hasError = true;
          newErrors.add = [
            ...newErrors.add,
            {
              id: id,
              message: errorLabel || <Message id="errorText.length"> + {length} </Message>,
            },
          ];
          return newErrors;
        }
        const suffix = record.substring(1);
        record = String(suffix).padStart(4, '0');
        record = 'M' + record;
      }
      result = `${result}${record}`;
    });
    if (hasError) return newErrors;
    value = result;
  }

  return ValidateRegExp({
    value,
    id,
    newErrors,
    validateAll,
    length,
    questionID,
    regExp,
    errorLabel
  });
};

export const ValidateRegExp = ({
  value,
  id,
  newErrors,
  validateAll,
  length,
  questionID,
  regExp,
  maxLimit,
  isOptional,
  errorLabel,
}) => {
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  }
  let invalid = false;

  if (!isOptional && (value === undefined || value === '')) {
    invalid = true;
  } else if ((value !== undefined) & (value !== '')) {
    invalid = value.length < length || invalid;
    invalid = (isOptional && maxLimit < value.length) || invalid;
    const INPUT_REGEX = XRegExp(regExp);
    invalid = !INPUT_REGEX.test(value) || invalid;
  } else {
    invalid = !isOptional && validateAll;
  }

  if (invalid) {
    newErrors.add = [
      ...newErrors.add,
      {
        id: id,
        message: errorLabel || (
          <Message id="errorText.length"> + {length} </Message>
        ),
      },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

export const ValidateNumeric = (...param) => {
  const [value, id, newErrors, validateAll, min, max, questionID, regExp,errorLabel] =
    param;
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  }
  let invalid = false;
  const invalidReg = !value.match(regExp);

  if (value !== undefined) {
    invalid =
      value === '' ||
      (value !== '' && (value < min || value > max || invalidReg)) ||
      invalid;
  } else {
    invalid = validateAll;
  }

  if (invalid) {
    newErrors.add = [
      ...newErrors.add,
      {
        id: id,
        message: errorLabel || (
          <Message id="errorText.notNumber">
            {' '}
            + {min} + {' - '} + {max}{' '}
          </Message>
        ),
      },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

export const ValidateDatePicker = (
  date,
  questions,
  id,
  newErrors,
  validateAll,
  questionID,
  errorLabel
) => {
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  } else if (getValue(questions.animalType)) {
    return validateAnimalBirth(questions, id, newErrors, errorLabel);
  }

  if (date) {
    newErrors.add = [
      ...newErrors.add,
      { id: id, message: errorLabel || <Message id="errorText.invalidDate" /> },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

export const ValidateSegmented = (
  value,
  id,
  newErrors,
  validateAll,
  questionID,
  errorLabel
) => {
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  }

  if ((value === undefined || value === '') && validateAll) {
    newErrors.add = [
      ...newErrors.add,
      {
        id: id,
        message: errorLabel || <Message id="errorText.invalidInput" />,
      },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

export const ValidateSSN = (
  value,
  id,
  newErrors,
  validateAll,
  length,
  questionID,
  ssn,
  errorLabel
) => {
  //do not validate if id and questionId is not same
  if ((validateAll === false) & (id !== questionID)) {
    return newErrors;
  }

  if (value !== ssn || value === '') {
    newErrors.add = [
      ...newErrors.add,
      {
        id: id,
        message: errorLabel || (
          <Message id="errorText.length"> + {length} </Message>
        ),
      },
    ];
  } else {
    newErrors.remove = [...newErrors.remove, id];
  }

  return newErrors;
};

const checkValidDate = (answer) => {
  return (answer || { isInvalid: true }).isInvalid;
};

const getDate = (answer) => {
  return (answer || { date: {} }).date;
};

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const validateAnimalBirth = (questions, id, newErrors, errorLabel) => {
  const currentDate = new Date();

  if (checkValidDate(questions.dateOfBirth)) {
    newErrors.add = [
      ...newErrors.add,
      {
        id: id,
        message: errorLabel || <Message id="errorText.invalidDate" />,
      },
    ];
  } else {
    const dateofbirth = new Date(getDate(questions.dateOfBirth));
    dateofbirth.setHours(0, 0, 0, 0);
    const maxLimit = new Date(currentDate.getFullYear() + 1, 11, 31);
    const minLimit = new Date(
      currentDate.getFullYear() -
        (getValue(questions.animalType) === 'Horse' ? 22 : 7),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    if (dateofbirth < minLimit || dateofbirth > maxLimit) {
      newErrors.add = [
        ...newErrors.add,
        {
          id: id,
          message: errorLabel || <Message id="errorText.invalidDate" />,
        },
      ];
    } else {
      newErrors.remove = [...newErrors.remove, id];
    }
  }
  return newErrors;
};
